function download_brochure(){
  if(document.querySelector('.modal-brochure #checkbox-download-brochure input') && document.querySelector('.modal-brochure #checkbox-download-brochure input').checked == true){
    document.querySelector('.modal-brochure .contact-form').style.display = "none";
    document.querySelector('.modal-brochure .wpcf7-response-output').style.display = "block";
    document.querySelector('.modal-brochure .contact-form-section').appendChild(document.querySelector('.modal-brochure .wpcf7-response-output'));
    document.querySelector('.modal-brochure .contact-form-section').appendChild(document.querySelector('.modal-brochure .download-brochure-link'));
    document.querySelector('.modal-brochure .download-brochure-link').style.display = "block";
    document.querySelector('.modal-brochure .wpcf7-response-output').style.display = "block";
  }
}

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        $('[data-toggle="tooltip"]').tooltip();

        if($('.masonry-container').length){
          $('.masonry-container').masonry({itemSelector: '.masonry-item'});
        }
        if($('.sticky-sidebar').length){
          $('.sticky-sidebar').stick_in_parent();
        }
        $('.tabbed-nav-scrollspy').on('click', 'li > a', function(e){
          e.preventDefault();
          $('.tabbed-nav-scrollspy').removeClass('in');
          $('html, body').animate({
            scrollTop: $($(this).attr('href')).offset().top - 80
          }, 400);
        })

      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {

        $('#home-slider').carousel({
          interval: false
        });

        //Gallery Carousel Slider
        if ($('.domain-carousel').length) {
          $('.domain-carousel').owlCarousel({
            loop: true,
            margin: 0,
            nav: true,
            autoplayHoverPause: false,
            autoplay: true,
            smartSpeed: 700,
            navText: [ '<span class="fa fa-angle-left"></span>', '<span class="fa fa-angle-right"></span>' ],
            responsive:{
              0:{
                items:1
              },
              600:{
                items:3
              },
              760:{
                items:6
              }
            }
          });
        }
        //Gallery Carousel Slider
        if ($('.gallery-carousel').length) {
          $('.gallery-carousel').owlCarousel({
            loop:true,
            margin:0,
            nav:true,
            autoplayHoverPause:false,
            autoplay: false,
            smartSpeed: 700,
            navText: [ '<span class="fa fa-angle-left"></span>', '<span class="fa fa-angle-right"></span>' ],
            responsive:{
              0:{
                items:1
              },
              600:{
                items:1
              },
              760:{
                items:2
              },
              1024:{
                items:2
              },
              1100:{
                items:2
              }
            }
          });
        }


      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
